var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BjDrawerForm",
        {
          ref: "BjDrawerForm",
          attrs: { form: _vm.form, rules: _vm.rules, width: "800px" },
          on: { handleConfirm: _vm.handleConfirm },
        },
        [
          _c(
            "el-col",
            { attrs: { span: 22 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("table.countText"), prop: "orderSeq" },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                      placeholder: _vm.$t("inputText"),
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.orderSeq,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "orderSeq", $$v)
                      },
                      expression: "form.orderSeq",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SettingBaseDataCodeRule.edit.type"),
                    prop: "fieldType",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      disabled: _vm.isEdit,
                      "constant-key": "CODE_RULE_FIELD_TYPE_LIST",
                    },
                    model: {
                      value: _vm.form.fieldType,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "fieldType", $$v)
                      },
                      expression: "form.fieldType",
                    },
                  }),
                ],
                1
              ),
              _vm.form.fieldType == "SEQUENCE"
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SettingBaseDataCodeRule.edit.editMin"),
                          prop: "seqLength",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.seqLength,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "seqLength", $$v)
                            },
                            expression: "form.seqLength",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "SettingBaseDataCodeRule.edit.editStart"
                          ),
                          prop: "startValue",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.startValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "startValue", $$v)
                            },
                            expression: "form.startValue",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.form.fieldType == "CONSTANT"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SettingBaseDataCodeRule.edit.value"),
                        prop: "fieldValue",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.fieldValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "fieldValue", $$v)
                          },
                          expression: "form.fieldValue",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.form.fieldType == "DATE"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SettingBaseDataCodeRule.edit.data"),
                        prop: "dateMask",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: { "lov-code": "HPFM.CODE_RULE.DATE_MASK" },
                        model: {
                          value: _vm.form.dateMask,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "dateMask", $$v)
                          },
                          expression: "form.dateMask",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.form.fieldType == "VARIABLE"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SettingBaseDataCodeRule.edit.variable"),
                        prop: "fieldValue",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: { "lov-code": "HPFM.CODE_RULE.VARIABLE" },
                        model: {
                          value: _vm.form.fieldValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "fieldValue", $$v)
                          },
                          expression: "form.fieldValue",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.form.fieldType == "UUID"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SettingBaseDataCodeRule.edit.number"),
                        prop: "fieldValue",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: { "constant-key": "UUID_LEN_LIST" },
                        model: {
                          value: _vm.form.fieldValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "fieldValue", $$v)
                          },
                          expression: "form.fieldValue",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }